(function () {
  'use strict';

  var DEFAULT_HANDLE = 'doprava-zasilkovna';
  var variantCache = {};

  function shippingHandle(root) {
    if (!root) return DEFAULT_HANDLE;
    return (root.getAttribute('data-shipping-handle') || DEFAULT_HANDLE).trim() || DEFAULT_HANDLE;
  }

  function resolveVariant(handle) {
    if (variantCache[handle]) return Promise.resolve(variantCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('product_not_found');
        return res.json();
      })
      .then(function (product) {
        var variants = product.variants || [];
        var variant = variants.find(function (v) {
          return v.available;
        }) || variants[0];
        var id = variant ? variant.id : null;
        if (id) variantCache[handle] = id;
        return id;
      })
      .catch(function () {
        return null;
      });
  }

  function cartHasMerchandise(cart, handle) {
    return (cart.items || []).some(function (item) {
      return item.handle !== handle;
    });
  }

  function findShippingLine(cart, handle) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return i + 1;
    }
    return 0;
  }

  function casentoEnsureCartShipping(root) {
    var handle = shippingHandle(root);
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var hasMerch = cartHasMerchandise(cart, handle);
        var line = findShippingLine(cart, handle);
        if (hasMerch && !line) {
          return resolveVariant(handle).then(function (variantId) {
            if (!variantId) return false;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1,
                    properties: { Doprava: 'Zásilkovna' }
                  }
                ]
              })
            }).then(function () {
              return true;
            });
          });
        }
        if (!hasMerch && line) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ line: line, quantity: 0 })
          }).then(function () {
            return true;
          });
        }
        return false;
      })
      .catch(function () {
        return false;
      });
  }

  window.casentoEnsureCartShipping = casentoEnsureCartShipping;
})();
